export function createGrupoMaterial() {
  return {
    Clave: '',
    EmpresaId: 0,
    Nombre: '',
    ClaveErp: '',
    EsActivo: true,
    CuentaContable: ''
  };
}
